module.exports = __webpack_public_path__ + "media/images/free-ticket-button@3x-94326743df62c0f30cb9af60199d1466.png";